import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-full w-full flex flex-col bg-paper" data-id="element-135">
      <SiteHeader data-id="element-136" />
      <main className="flex-1 w-full" data-id="element-137">{children}</main>
      <SiteFooter data-id="element-138" />
    </div>;
}